import { mapGetters } from 'vuex'
import Add from './add.dialog.vue'
import banner from '../../../../api/banner'

const columns = [
  {
    title: '',
    enTitle: 'Image',
    width: 200,
    dataIndex: 'picture',
    slot: 'img',
  },
  {
    title: '',
    enTitle: 'Title',
    width: 200,
    dataIndex: 'nameText',
    slot: 'omission',
  },
  {
    title: '',
    enTitle: 'Link',
    width: 200,
    dataIndex: 'linkAddress',
    slot: 'link',
  },
  {
    title: '',
    enTitle: 'Operation Time',
    width: 150,
    dataIndex: 'updateTime',
    slot: 'time',
  },
  {
    title: '',
    enTitle: 'Status',
    width: 100,
    dataIndex: 'released',
    slot: 'status',
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 150,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions',
  },
]
export default {
  components: {
    Add,
  },
  data() {
    return {
      columns,
      isVisable: false,
      dataSource: [],
      params: {
        released: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      domain: 'getDomain',
      user: 'getUser',
    }),
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      this.dataSource = await banner.getAll(this.params)
    },
    changeStatus(status) {
      this.params.released = status
      this.getList()
    },
    add() {
      this.isVisable = true
    },
    edit(val) {
      this.$refs['banner-add'].getQuery(val.id)
      this.isVisable = true
    },
    async able(val) {
      const { id, released, version } = val
      await banner.release(id, !released, { version })
      let content = 'This Banner has been published!'
      if (released) {
        content = 'This Banner has been unpublished!'
      }
      this.$message.success({
        title: 'Success',
        content: content,
      })
      this.getList()
    },
    del(val) {
      this.$confirm({
        title: 'Are you sure you want to delete this banner?',
        content:
          'Please be aware that once this banner is deleted, it will never be able to be recovered.',
        type: 'danger',
        icon: 'iconDelete',
      }).then(async () => {
        await banner.del(val.id)
        this.$message.success({
          title: 'Success',
          content: 'This Banner has been deleted!',
        })
        this.getList()
      })
    },
    async setSort(val) {
      val.forEach((item, index) => {
        item.sort = index
      })
      await banner.setSort(val)
      this.getList()
    },
    confirm() {
      this.getList()
      this.isVisable = false
    },
    cancel() {
      this.isVisable = false
    },
  },
}
